import { GENERAL_SERVICES_NAMES } from './_generalServices.names';
import { VEHICLE_PURCHASE_SERVICES_NAMES } from './_vehiclePurchaseServices.names';
import { WORKSHOP_SERVICES_NAMES } from './_workshopServices.names';

/**
 * @typedef {import('./_generalServices.names').GENERAL_SERVICES} GeneralServices
 * @typedef {import('./_vehiclePurchaseServices.names').VEHICLE_PURCHASE_SERVICES} VehiclePurchaseServices
 * @typedef {import('./_workshopServices.names').WORKSHOP_SERVICES} WorkshopServices
 *
 * @typedef {GeneralServices|VehiclePurchaseServices|WorkshopServices} AllServicesNames
 *
 * @typedef {'GENERAL_SERVICES'|'VEHICLE_PURCHASE_SERVICES'|'WORKSHOP_SERVICES'} DealerProfileServiceCategoryKey
 * @typedef {'generalServices'|'vehiclePurchaseServices'|'workshopServices'} DealerProfileServiceCategoryValue
 *
 * @const SERVICE_CATEGORIES_NAMES
 * @type {Record<DealerProfileServiceCategoryKey, DealerProfileServiceCategoryValue>}
 *
 * @description
 * top-level service categories names
 *
 */
export const SERVICE_CATEGORIES_NAMES = {
  GENERAL_SERVICES: 'generalServices',
  VEHICLE_PURCHASE_SERVICES: 'vehiclePurchaseServices',
  WORKSHOP_SERVICES: 'workshopServices',
};

/**
 *
 * @const ALL_SERVICE_NAMES
 * @type {Record<DealerProfileServiceCategoryValue, AllServicesNames>}
 *
 * @description
 * dictionary of all service names indexed by category name
 */
export const ALL_SERVICE_NAMES = {
  [SERVICE_CATEGORIES_NAMES.GENERAL_SERVICES]: GENERAL_SERVICES_NAMES,
  [SERVICE_CATEGORIES_NAMES.VEHICLE_PURCHASE_SERVICES]: VEHICLE_PURCHASE_SERVICES_NAMES,
  [SERVICE_CATEGORIES_NAMES.WORKSHOP_SERVICES]: WORKSHOP_SERVICES_NAMES,
};
